import React, {useState} from 'react';
import Header from "../components/Header";
import ContactModal from "../components/ContactModal";

const Datenschutzerklaerung = () => {

    const companyInfo = {
        name: "Milo & Mabel Hundefriseur Scheyern / Susanne Wingens",
        address: "Winden 1a, 85298 Scheyern, Deutschland",
        email: "info@hundefriseur-scheyern.de",
        phone: "08445 - 9295636",
        website: "www.hundefriseur-scheyern.de"
    };
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(prev => !prev);

    return (
        <div className="datenschutz-container" style={styles.container}>
            <Header onContactClick={toggleModal} />
            <h1 style={styles.mainHeading}>Datenschutzerklärung</h1>

            {/* --- 1. Überblick --- */}
            <section style={styles.section}>
                <h2 style={styles.subHeading}>1. Datenschutz auf einen Blick</h2>
                <h3>Allgemeine Hinweise</h3>
                <p>
                    Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert,
                    wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                </p>
            </section>

            {/* --- 3. Allgemeine Hinweise --- */}
            <section style={styles.section}>
                <h2 style={styles.subHeading}>2. Allgemeine Hinweise und Pflichtinformationen</h2>

                <h3>Datenschutz</h3>
                <p>
                    Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst.
                    Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften
                    sowie dieser Datenschutzerklärung.
                </p>

                <h3>Hinweis zur verantwortlichen Stelle</h3>
                <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
                <address style={styles.address}>
                    <strong>{companyInfo.name}</strong><br />
                    {companyInfo.address}<br /><br />
                    E-Mail: <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a><br />
                    {companyInfo.phone && <span>Telefon: {companyInfo.phone}</span>}
                </address>
            </section>

            {/* --- 4. Datenerfassung --- */}
            <section style={styles.section}>
                <h2 style={styles.subHeading}>3. Datenerfassung auf dieser Website</h2>

                <h3>Cookies</h3>
                <p>
                    Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an.
                    Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
                </p>

                <h3>Kontaktformular / E-Mail</h3>
                <p>
                    Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben zwecks Bearbeitung der Anfrage gespeichert.
                    Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
            </section>

            {/* --- 5. Analyse Tools & Werbung (OPTIONAL - LÖSCHEN WENN NICHT BENÖTIGT) --- */}
            <section style={styles.section}>
                <h2 style={styles.subHeading}>4. Analyse-Tools und Werbung</h2>

                <h3>Google Analytics</h3>
                <p>
                    Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Ireland Limited („Google“),
                    Gordon House, Barrow Street, Dublin 4, Irland.
                </p>
                <p>
                    Google Analytics verwendet so genannte „Cookies“. Das sind Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen.
                    Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.
                </p>
                <p>
                    <strong>IP-Anonymisierung:</strong> Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europäischen Union
                    oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum vor der Übermittlung in die USA gekürzt.
                </p>
            </section>

            {/* --- 6. Plugins und Tools (OPTIONAL - LÖSCHEN WENN NICHT BENÖTIGT) --- */}
            <section style={styles.section}>
                <h2 style={styles.subHeading}>5. Plugins und Tools</h2>

                <h3>Google Web Fonts (via Google Server)</h3>
                <p>
                    Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts, die von Google bereitgestellt werden.
                    Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.
                </p>
                <p>
                    Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google aufnehmen.
                    Hierdurch erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse diese Website aufgerufen wurde.
                    Die Nutzung von Google Web Fonts erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
                </p>
            </section>

            {/* --- 7. Rechte des Nutzers --- */}
            <section style={styles.section}>
                <h2 style={styles.subHeading}>6. Ihre Rechte</h2>
                <p>
                    Sie haben jederzeit das Recht auf unentgeltliche <strong>Auskunft</strong>, <strong>Berichtigung</strong>, <strong>Löschung</strong> sowie <strong>Einschränkung der Verarbeitung</strong> Ihrer Daten.
                    Zudem haben Sie ein Recht auf <strong>Datenübertragbarkeit</strong> und ein <strong>Beschwerderecht</strong> bei der zuständigen Aufsichtsbehörde.
                </p>
            </section>
            <ContactModal show={showModal} onClose={toggleModal} />
        </div>
    );
};
// --- Styles ---
const styles = {
    container: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '2rem',
        lineHeight: '1.6',
        color: '#333'
    },
    mainHeading: {
        borderBottom: '2px solid #eaeaea',
        paddingBottom: '1rem',
        marginBottom: '2rem',
        fontSize: '2rem'
    },
    section: {
        marginBottom: '2.5rem'
    },
    subheading: {
        fontSize: '1.2rem',
        marginTop: '1.5rem',
        marginBottom: '0.5rem'
    },
    address: {
        fontStyle: 'normal',
        backgroundColor: '#f8f9fa',
        padding: '1.5rem',
        borderRadius: '8px',
        marginTop: '1rem',
        marginBottom: '1rem',
        border: '1px solid #e9ecef'
    }
};
export default Datenschutzerklaerung;